<template>
    <div class="compare-group">
        <b-button
            class="compare-button"
            variant="primary"
            :pressed="isCompareView"
            :disabled="selectedForComparison.length < 2"
            @click.stop="switchCompareView"
        >
            <span class="compare-text">{{ compareButtonText }}</span>
            <span class="c-text">{{ cButtonText }}</span>
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { TREATMENT_PAGE_VIEWS } from '../../../business/const'

export default {
    name: 'CompareGroup',
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView,
            previousTreatmentView: state => state.navigation.previousTreatmentView,
            selectedSlide: state => state.timelapse.selectedSlide,
            selectedTreatment: state => state.timelapse.selectedTreatment,
            selectedForComparison: state => state.timelapse.selectedForComparison
        }),
        isCompareView() {
            return this.currentView === TREATMENT_PAGE_VIEWS.COMPARE_WELLS
        },
        comparedCount() {
            return this.selectedForComparison.length ? `(${this.selectedForComparison.length})` : ''
        },
        compareButtonText() {
            return this.isCompareView
                ? this.$translate('done')
                : `${this.$translate('compare')}${this.comparedCount}`
        },
        cButtonText() {
            return this.isCompareView ? this.$translate('done') : `C${this.comparedCount}`
        }
    },
    methods: {
        switchCompareView() {
            const { COMPARE_WELLS, WELL_CARDS } = TREATMENT_PAGE_VIEWS

            const to = this.isCompareView ? this.previousTreatmentView || WELL_CARDS : COMPARE_WELLS

            this.$store.dispatch('navigation/switchTreatmentView', to)
        }
    }
}
</script>

<style lang="scss" scoped>
.compare-group {
    display: flex;

    .compare-button {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        white-space: nowrap;
        margin: 0 0.5rem;

        &.active {
            background: $blue !important;
            color: $dark-4 !important;
            font-weight: bold;
        }

        @media screen and #{$new-break2close} {
            .compare-text {
                display: none;
            }
        }
        @media screen and #{$new-break3open} {
            .c-text {
                display: none;
            }
        }
    }
}
</style>
